import { List, Row } from "antd";
import React from "react";
import Slider from "react-slick";
import { Arrow } from "../images";
import CertificationItem from "./certificationItem";
import "./style.scss";

const ProductCertifications = (props: any) => {
  const { certifications } = props;
  let slider: any = React.useRef();
  const [visibleArrowLeft, setVisibleArrowLeft] = React.useState(false);
  const [visibleArrowRight, setVisibleArrowRight] = React.useState(
    certifications?.length > 3 ? true : false
  );

  // const data = [
  //   {
  //     name: "Mousse cao su thiên nhiên nệm KYMDAN có khả năng kháng cháy, được chứng nhận bởi Bureau of Household Goods and Services, California, Hoa Kỳ",
  //     img: {
  //       path: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1618467563-Hinhbangchungnhan.TrangchitietSP120x92px-05.jpg",
  //     },
  //   },
  //   {
  //     name: "Chứng nhận thành viên Hiệp hội Ngành Hàng Nội Thất Australia",
  //     img: {
  //       path: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1618467555-Hinhbangchungnhan.TrangchitietSP120x92px-06.jpg",
  //     },
  //   },
  //   {
  //     name: "Chứng nhận Phòng Thí nghiệm KYMDAN phù hợp bộ tiêu chuẩn quốc tế ISO/IEC 17025:2017",
  //     img: {
  //       path: "https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1618467547-Hinhbangchungnhan.TrangchitietSP120x92px-07.jpg",
  //     },
  //   },
  // ];

  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    accessibility: true,
    speed: 500,
    // centerMode: true,
    // centerPadding: "50px",
    slidesToShow: certifications?.length >= 3 ? 3 : certifications?.length,
    slidesToScroll: 3,
    rows: 1,
    beforeChange: (current: any, next: any) => {
      setVisibleArrowLeft(false);
      setVisibleArrowRight(true);
      if (next + 3 >= certifications?.length) {
        // if (next + 3 >= data?.length) {
        setVisibleArrowRight(false);
      }
      if (next) {
        setVisibleArrowLeft(true);
      }
    },
  };

  return (
    <Row
      align="middle"
      justify="center"
      className="product-certification-wrapper">
      {certifications.length ? (
        <List
          grid={{
            column: 2,
          }}
          className="product-certification-list-wrapper"
          dataSource={certifications}
          // dataSource={data}
          renderItem={(item: any) => (
            <CertificationItem key={item._id} certification={item} />
          )}
        />
      ) : null}
      <div className="product-certification-slider-wrapper">
        {visibleArrowLeft ? (
          <a className="kd-btn-arrow-left" onClick={() => slider.slickPrev()}>
            <img src={Arrow} style={{ width: 30 }} alt="Next" />
          </a>
        ) : null}
        {certifications && certifications.length ? (
          <Slider
            {...settings}
            ref={(c) => (slider = c)}
            className="product-certification-slider">
            {/* {data?.map((item: any, i: number) => ( */}
            {certifications?.map((item: any, i: number) => (
              <CertificationItem key={item._id} certification={item} />
            ))}
          </Slider>
        ) : null}
        {visibleArrowRight ? (
          <a className="kd-btn-arrow-right" onClick={() => slider.slickNext()}>
            <img
              src={Arrow}
              style={{ width: 30, transform: "scaleX(-1)" }}
              alt="Next"
            />
          </a>
        ) : null}
      </div>
    </Row>
  );
};

export default ProductCertifications;
